<div (dropped)="startUpload($event)"
     (hovered)="toggleHover($event)"
     [class.hovering]="isHovering"
     class="dropzone"
     dropZone>

    <div class="file">
        <label class="file-label">
            <input (change)="startUpload($event)" class="file-input" type="file">
            <span class="file-cta">
        <span class="file-icon">
          <i class="fa fa-upload"></i>
        </span>
      </span>
        </label>
    </div>
</div>


@if (snapshot | async; as snap) {
    <div>
        @if (percentage | async; as pct) {
            <div>
                @if (isActive(snap)) {
                    <progress [value]="pct"
                              class="progress is-info"
                              max="100">
                    </progress>
                }
                @if (isActive(snap)) {
                    <span>{{ pct | number }}%</span>
                }
            </div>
        }
        <!--<div *ngIf="downloadURL | async as url">
        <h3>Results!</h3>
        <img [src]="url"><br>
        <a [href]="url" target="_blank" rel="noopener">Download Me!</a>
      </div> -->
        @if (isActive(snap)) {
            <div>
                <button (click)="task.pause()" [disabled]="!isActive(snap)" class="button is-warning" mat-raised-button>
                    Pause
                </button>
                <button (click)="task.cancel()" [disabled]="!isActive(snap)" class="button is-danger" mat-raised-button>
                    Cancel
                </button>
                <button (click)="task.resume()" [disabled]="!(snap?.state === 'paused')" class="button is-info"
                        mat-raised-button>Resume
                </button>
            </div>
        }
    </div>
}